<template>

  <div class="container-fluid">
    <form class="form-horizontal">
      <div class="form-group">
        <label class="control-label col-sm-2">{{$t('pages.createGroup.name')}}:</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="nameOfGroup">
        </div>
      </div>
      <div class="form-group">
        <label class="control-label col-sm-2">{{$t('pages.createGroup.description')}}:</label>
        <div class="col-sm-10">
          <input type="text" class="form-control" v-model="descriptionOfGroup">
        </div>
      </div>
      <div class="checkbox text-center">
        <label class="checkbox-inline">
          <input v-model="visibility" type="checkbox"> {{$t('pages.createGroup.visibility')}}
        </label>
        <label class="checkbox-inline">
          <input v-model="dynamic" type="checkbox"> {{$t('pages.createGroup.dynamic')}}
        </label>
      </div>
      <div class="checkbox text-center">
        <label>
          <input v-model="public_a" type="checkbox"> {{$t('pages.createGroup.public')}}
        </label>
      </div>
      <div class="form-group">
        <div class="col-sm-offset-2 col-sm-10">
          <button @click.stop="createNewSubgroup" class="btn btn-app pull-right">
            <i class="fa fa-plus"></i>{{Create}}
          </button>
        </div>
      </div>
    </form>
  </div>

</template>

<script>
// import { EventBus } from './../events/event-bus.js'
import Rest from './../../../services/rest'
export default {
  data () {
    return {
      nameOfGroup: '', // requied
      descriptionOfGroup: '',
      coverPhotoUrl: '',
      groupStatus: '',
      Create: this.$t('pages.buttons.create'),
      dynamic: false,
      visibility: true,
      public_a: false
    }
  },
  props: {
    gid: {
      required: true
    },
    sid: {
      required: true
    }
  },
  methods: {
    createNewSubgroup (event) {
      // e.preventDefault()
      event.preventDefault()
      let postdata = {
        groupId: this.gid,
        name: this.nameOfGroup,
        description: this.descriptionOfGroup,
        parentId: (this.sid === 'root') ? null : this.sid,
        visible: this.visibility,
        public: this.public_a,
        dynamic: this.dynamic
      }
      this.Create = this.$t('pages.buttons.success')
      return Rest.request('POST', '/subgroups', postdata).then((data) => {
        // EventBus.$emit('updateSGList', data)
        this.$store.commit('addNewSubgroup', data)
        this.nameOfGroup = ''
        this.descriptionOfGroup = ''
        this.$store.commit('toggleCreateSubgroup')
      }).catch((err) => {
        console.log(err)
        this.Create = this.$t('pages.buttons.fail')
      })
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CreateSubgroup.vue?2d91b1f8